import { CIcon } from '~/icons/types'

export const ciFatBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M18.443 9.981a4.524 4.524 0 0 0-1.26.198l-.45-1.266c-.002-.005 0-.01-.002-.015l-.271-.764c-.004-.01-.01-.018-.015-.028l-.866-2.43v-.002l-.008-.02a.476.476 0 0 0-.027-.045.49.49 0 0 0-.07-.116.477.477 0 0 0-.048-.041.485.485 0 0 0-.102-.076.498.498 0 0 0-.076-.024.475.475 0 0 0-.095-.03L13.08 5.1a.5.5 0 1 0-.107.994l1.761.189.553 1.551-5.804.269-.22-.505.572.002h.001a.5.5 0 0 0 .002-1l-2.322-.008h-.002a.5.5 0 0 0-.001 1l.657.002.296.68a.487.487 0 0 0-.1.1l-1.229 2.003a4.588 4.588 0 1 0 2.69 4.691h.768a1.296 1.296 0 0 0 1.078.6 1.327 1.327 0 0 0 1.33-1.32 1.288 1.288 0 0 0-.085-.413l3.166-3.865.175.491a4.55 4.55 0 1 0 2.185-.58Zm-9.507-.627 1.78 4.087a1.32 1.32 0 0 0-.308.627h-.582a4.563 4.563 0 0 0-1.829-3.183Zm-.61 4.714h-2.28l1.164-1.897a3.069 3.069 0 0 1 1.116 1.897ZM5.29 17.653a3.086 3.086 0 1 1 0-6.171 3.052 3.052 0 0 1 1.049.195l-1.612 2.63a.5.5 0 0 0 .426.761h3.173a3.084 3.084 0 0 1-3.036 2.585Zm6.963-4.485a1.293 1.293 0 0 0-.582-.15c-.016 0-.029.008-.045.009L9.909 9.084l5.728-.265.054.152Zm6.19 4.485a3.082 3.082 0 0 1-1.678-5.669l.98 2.754a.501.501 0 0 0 .472.332.483.483 0 0 0 .168-.029.5.5 0 0 0 .303-.639l-1.003-2.815a3.05 3.05 0 0 1 .758-.106 3.086 3.086 0 1 1 0 6.172Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'fat-bike',
  type: 'thin'
}
